import BinIcon from '../../../../components/icon/IconWrapped';
import React from 'react';
import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import UserStatusCongratulationsBenefitsCard from './UserStatusCongratulationsBenefitsCard';
import {
    UserStatusCongratulationsBenefitsCardBadgeIconStyled,
} from './styled/UserStatusCongratulationsBenefitsCardStyled';

function UserStatusCongratulationsBenefitsRespawn() {
    const { getLangPath } = useLangContext();

    return <UserStatusCongratulationsBenefitsCard
        badgeComponent={
            <UserStatusCongratulationsBenefitsCardBadgeIconStyled>
                <BinIcon name={'IcRebuyColor'} size={24}/>
            </UserStatusCongratulationsBenefitsCardBadgeIconStyled>
        }
    >
        <span className={'text-secondary f14'}>{getLangPath('user_statuses.respawn.title')}</span>
    </UserStatusCongratulationsBenefitsCard>;
}

export default UserStatusCongratulationsBenefitsRespawn;
